import React, {useState,useEffect} from 'react';
import Axios from 'axios'; 
import './App.css';
import Header from './Component/Header';
import Recipes from './Component/Recipes';
import Footer from './Component/Footer';
function App() {
 
  const [search, setSerach]=useState("banana")
  const [recipes,setRecipes]=useState([]);
  const APP_ID="b1532f6e";
  const APP_KEY="818b7f2118025b358a223dab46e9826b";

  useEffect( () =>{
      getRecipes();
      
 
  },[]);
  const getRecipes =async()=>{
    const res=await Axios.get(`https://api.edamam.com/search?q=${search}&app_id=${APP_ID}&app_key=${APP_KEY}`);
    // console.log(res);
    setRecipes(res.data.hits)
    setSerach("");
  }
  const onSearchClick=()=>{
    getRecipes();
  };

  const inputChange=(e)=>{
      setSerach(e.target.value)
  }
  const myStyle={
    minHeight:"69vh"
  };
  return (
    <div>
     
     <Header search={search} inputChange={inputChange} onSearchClick={onSearchClick}/>
     <div className="container" style={myStyle}>
     <Recipes recipes={recipes}/>
     </div>
    <Footer/>
    </div>
  );
}

export default App;
